import { AuthContextProps } from '@lib/firebase/provider'
import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import type { ListStateService } from '@lib/listState/service'

interface RouterContext {
  auth: AuthContextProps | null
  setOrg: (orgId: string) => void
  getTitle: () => string
  listState: ListStateService
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
})
